import { useCallback, useState } from 'react';
import { useMenuContext } from '../context/menuContext';
import { staffTipEligibility } from '../services/StaffTipService';

// Discovery is owned by MenuContext: no report probe, extra discovery cache, or
// credential-derived cache key. Its request generation guards every completion.
export const useStaffTipEligibility = () => {
  const { selectedRestaurant, sessionKey, isLoading, discoveryError, refreshRestaurants, expireSession } = useMenuContext();
  const key = JSON.stringify([sessionKey, selectedRestaurant?.id]);
  const [failure, setFailure] = useState(null);
  const retry = useCallback(() => {
    setFailure(null);
    refreshRestaurants();
  }, [refreshRestaurants]);
  const onReportError = useCallback((error) => {
    // Latch errors until explicit retry. A stale-positive discovery response must
    // not remount the report and start an endless report→discovery retry loop.
    setFailure({ key, error });
    if (Number(error?.status) === 401) expireSession();
    else refreshRestaurants();
  }, [key, refreshRestaurants, expireSession]);
  const onConfiguredChange = useCallback((configured) => {
    if (!configured) onReportError({ status: 409 });
  }, [onReportError]);
  const error = failure?.key === key ? failure.error : discoveryError;
  let state = 'unknown';
  if (error) state = Number(error.status) === 403 ? 'access_denied'
    : Number(error.status) === 409 ? 'configuration_error' : 'network_error';
  else if (isLoading) state = 'loading';
  else if (sessionKey && selectedRestaurant) state = staffTipEligibility(selectedRestaurant);
  return {
    state, error, loading: state === 'loading', configured: state === 'enrolled',
    timezone: selectedRestaurant?.timezone, retry, onReportError, onConfiguredChange,
  };
};
